import { render, staticRenderFns } from "./FormFileItem.vue?vue&type=template&id=29968a43&scoped=true"
import script from "./FormFileItem.vue?vue&type=script&lang=js"
export * from "./FormFileItem.vue?vue&type=script&lang=js"
import style0 from "./FormFileItem.vue?vue&type=style&index=0&id=29968a43&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29968a43",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29968a43')) {
      api.createRecord('29968a43', component.options)
    } else {
      api.reload('29968a43', component.options)
    }
    module.hot.accept("./FormFileItem.vue?vue&type=template&id=29968a43&scoped=true", function () {
      api.rerender('29968a43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TkCommonPage/components/tableComp/formItems/FormFileItem.vue"
export default component.exports